import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Resolve, Router} from '@angular/router';
import {from, Observable, of} from 'rxjs';
import {KundeService} from '../kunden/kunde.service';
import {catchError, map, switchMap} from 'rxjs/operators';
import {MandantenService} from '../mandanten/mandanten.service';

@Injectable({ providedIn: 'root' })

export class ExpressLoginGuard implements CanActivate {

  constructor(
    private mandantenService: MandantenService,
    private kundenService: KundeService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (navigator.clipboard && navigator.clipboard.readText) {
      return from(navigator.clipboard.readText()).pipe(
        switchMap((clipboard) => {
          let autologin = JSON.parse(clipboard);
          return this.kundenService.kunde_login({
            user: autologin.login,
            password: autologin.password,
          })
        }),
        map((kunde) => {
          this.mandantenService.mandant_get().subscribe(mandant => {
            if (mandant.navigation_logged_in_default === 'home') {
              this.router.navigateByUrl('/home')
            } else if (mandant.navigation_logged_in_default === 'menu') {
              this.router.navigateByUrl('/speiseplan-kunde')
            }
          })
          return true
        }),
        catchError(err => {
          return of(true)
        }),
      )
    }
  }
}
